<template>
  <MainLite />
</template>
<script>
import MainLite from './components/lite/Main.vue';
import { mapGetters } from "vuex";
export default {
  components: {
    MainLite,
  },
  computed: {
    ...mapGetters(['view_plan',]),
  },
}
</script>
